import { customerApiClient } from './customer-api-client';
import type {
  CustomerJobDetail,
  CustomerJobListData,
  CustomerJobListQuery,
} from '@/types/customer-job.types';

export const customerJobService = {
  list: (query: CustomerJobListQuery): Promise<CustomerJobListData> =>
    customerApiClient
      .get<CustomerJobListData>('/customer-portal/jobs', { params: query })
      .then((r) => r.data),

  getById: (id: string): Promise<CustomerJobDetail> =>
    customerApiClient.get<CustomerJobDetail>(`/customer-portal/jobs/${id}`).then((r) => r.data),
};
